import React, { useState, useRef, useEffect } from "react";

interface TrackingTimeDropdownProps {
    label: string;
    selectedOption: "Days" | "Hours" | null;
    onSelectionChange: (selected: "Days" | "Hours") => void;
}

const TrackingTimeDropdown: React.FC<TrackingTimeDropdownProps> = ({ 
    label, 
    selectedOption, 
    onSelectionChange, 
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const options: Array<"Days" | "Hours"> = ["Days", "Hours"];

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelection = (option: "Days" | "Hours") => {
        onSelectionChange(option);
        setIsOpen(false);
    };

    return (
        <div className="relative flex-1" ref={dropdownRef}>
            <label className="block text-gray-700 font-semibold mb-2">{label}</label>

            {/* Selected Value */}
            <div
                className="relative min-w-[200px] border rounded-lg p-2 cursor-pointer bg-white flex items-center justify-between"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="truncate">
                    {selectedOption ?? "Select tracking time"}
                </span>
                <span className="ml-2">&#9662;</span> {/* Dropdown Arrow */}
            </div>

            {/* Dropdown Options */}
            {isOpen && (
                <div className="absolute z-10 flex flex-col mt-2 bg-white border rounded-lg shadow-lg min-w-[200px] max-w-[300px]">
                    <div className="max-h-40 overflow-y-auto">
                            {options.map((option) => (
                                <div
                                    key={option}
                                    className="p-2 cursor-pointer hover:bg-gray-100"
                                    onClick={() => handleSelection(option)}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                </div>
            )}
        </div>
    );
};

export default TrackingTimeDropdown;
